var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('informacionOferta',{attrs:{"set-loader":_vm.loader,"detalle":_vm.detalle,"error":_vm.error}}),_c('informacionOfertaTabs',{attrs:{"set-loader":_vm.loader,"detalle":_vm.detalle,"error":_vm.error}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }